<div class="p-grid">
	<div class="p-col-12 p-md-4">
		<div class="card d-flex flex-column m-2 p-0 h-100">
			<div class="d-flex">
				<div class="h3 mx-4 mt-2 mb-1">Add new Menu Section</div>
			</div>
			<p-divider></p-divider>
			<div class="d-flex flex-column">
				<div class="mt-2 mx-2 flex-fill">
					<mat-form-field class="w-100">
						<mat-label>Parent Category</mat-label>
						<mat-select #parentCategory (valueChange)="(null)" name="parentCategory" class="" [(ngModel)]="selectedMenu.parentKey">
							<mat-option *ngFor="let value of parentCategories" [value]="value.key">
								{{ value.label }}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<mat-form-field class="mt-2 mx-2 flex-fill">
					<mat-label>Label</mat-label>
					<input matInput #label type="text" name="label" [(ngModel)]="selectedMenu.label" />
				</mat-form-field>
				<mat-form-field class="mt-2 mx-2 flex-fill">
					<mat-label>Icon Type</mat-label>
					<mat-select
						#faIconPrefix
						name="faIconPrefix"
						[(ngModel)]="selectedMenu.faIconPrefix"
						[disabled]="!selectedMenu.parentKey || selectedMenu.parentKey === undefined"
					>
						<mat-option *ngFor="let value of fontAwesomePrefix" [value]="value.value">
							{{ value.label }}
						</mat-option>
					</mat-select>
				</mat-form-field>
				<div class="d-flex">
					<mat-form-field class="mt-2 mx-2">
						<mat-label>Icon Idenfitier</mat-label>
						<input
							matInput
							#faIcon
							type="text"
							name="faIcon"
							[(ngModel)]="selectedMenu.faIcon"
							[disabled]="!selectedMenu.parentKey || selectedMenu.parentKey === undefined"
						/>
					</mat-form-field>
					<fa-icon
						*ngIf="selectedMenu.faIconPrefix && selectedMenu.faIcon"
						[icon]="[selectedMenu.faIconPrefix, selectedMenu.faIcon]"
						size="2x"
					></fa-icon>
				</div>
				<mat-form-field class="mt-2 mx-2 flex-fill">
					<mat-label>Router Link Address</mat-label>
					<input
						matInput
						#routerLinkAddress
						type="text"
						name="routerLinkAddress"
						[(ngModel)]="selectedMenu.routerLink"
						[disabled]="!selectedMenu.parentKey || selectedMenu.parentKey === undefined"
						placeholder="/cc/admin/menusetup"
					/>
				</mat-form-field>
				<mat-form-field class="mt-2 mx-2 flex-fill">
					<mat-label>User Role Required</mat-label>
					<mat-select #itemUserLevel name="itemUserLevel" [(ngModel)]="selectedMenu.itemUserLevel">
						<mat-option *ngFor="let value of userRole" [value]="value.value">
							{{ value.label }}
						</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field class="mt-2 mx-2 flex-fill">
					<mat-label>Sort Order</mat-label>
					<input matInput #sortOrder type="number" name="sortOrder" [(ngModel)]="selectedMenu.sortOrder" />
				</mat-form-field>
			</div>
			<div class="d-flex">
				<p-button pRipple styleClass="p-button-raised p-button-success m-2" (click)="saveMenuChanges()">
					<ng-template pTemplate="content">
						<div class="d-flex justify-content-center">
							<fa-icon [icon]="['far', 'save']" size="lg" class="ms-1 me-2"></fa-icon>
							Save Section
						</div>
					</ng-template>
				</p-button>
				<p-button pRipple styleClass="p-button-raised p-button-danger m-2" (click)="deleteMenuSection()" [disabled]="!selectedMenu.key">
					<ng-template pTemplate="content">
						<div class="d-flex justify-content-center">
							<fa-icon [icon]="['far', 'times']" size="lg" class="ms-1 me-2"></fa-icon>
							Delete Section
						</div>
					</ng-template>
				</p-button>
			</div>
			<div class="d-flex">
				<div class="d-flex w-100">
					<span class="p-float-label mt-4 flex-fill">
						<input pInputText #menuSectionKey name="menuSectionKey" type="text" [(ngModel)]="selectedMenu.key" class="w-100" [disabled]="true" />
						<label for="menuSectionKey">Menu Section Key</label>
					</span>
					<fa-icon [icon]="['far', 'copy']" (click)="app.copyMessage(selectedMenu.key)" class="ms-2 my-auto" size="lg"></fa-icon>
				</div>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-md-4">
		<div class="card h-100">
			<p-tree *ngIf="menuTreeFormat" [value]="menuTreeFormat" selectionMode="single" (onNodeSelect)="selectExistingMenu($event)"></p-tree>
			<p-button pRipple styleClass="p-button-raised p-button-info m-2" (click)="newMenuSection()">
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">
						<fa-icon [icon]="['far', 'plus']"></fa-icon>
						<fa-icon [icon]="['far', 'bars']" size="lg" class="ms-1 me-2"></fa-icon>
						New Section
					</div>
				</ng-template>
			</p-button>
		</div>
	</div>
</div>
